
    (function() {
      var root = document.getElementById('sb-w21-reviews-007');
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var tabs = root.querySelectorAll('.sb-tab');
      var panels = root.querySelectorAll('.sb-tab-panel');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-tab');

          tabs.forEach(function(item) {
            var active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function(panel) {
            panel.hidden = panel.getAttribute('data-panel') !== target;
          });
        });
      });

      var questionButton = root.querySelector('.sb-question-button');
      var writeButton = root.querySelector('.sb-write-button');
      var questionForm = root.querySelector('.sb-question-form');
      var reviewForm = root.querySelector('.sb-review-form');

      if (questionButton && questionForm) {
        questionButton.addEventListener('click', function() {
          questionForm.hidden = !questionForm.hidden;
          if (reviewForm) reviewForm.hidden = true;
        });
      }

      if (writeButton && reviewForm) {
        writeButton.addEventListener('click', function() {
          reviewForm.hidden = !reviewForm.hidden;
          if (questionForm) questionForm.hidden = true;
        });
      }

      root.querySelectorAll('.sb-black-form-btn').forEach(function(button) {
        button.addEventListener('click', function() {
          var form = button.closest('.sb-inline-form');
          if (!form) return;
          form.innerHTML = '<p style="margin:0;font-size:14px;line-height:23.1px;">Thank you for submitting your ' +
            (form.classList.contains('sb-question-form') ? 'question!' : 'review!') +
            '</p>';
        });
      });

      root.querySelectorAll('.sb-share-toggle').forEach(function(button) {
        button.addEventListener('click', function() {
          var share = button.closest('.sb-share');
          if (share) share.classList.toggle('is-open');
        });
      });

      var lightbox = root.querySelector('.sb-lightbox');
      var lightboxImage = lightbox ? lightbox.querySelector('img') : null;
      var lightboxClose = lightbox ? lightbox.querySelector('.sb-lightbox-close') : null;

      root.querySelectorAll('.sb-customer-photo, .sb-review-image').forEach(function(button) {
        button.addEventListener('click', function() {
          var image = button.querySelector('img');
          if (!image || !lightbox || !lightboxImage) return;

          lightboxImage.src = image.src;
          lightboxImage.alt = image.alt || 'Customer review photo';
          lightbox.classList.add('is-open');
          lightbox.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
        });
      });

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }

      if (lightboxClose) {
        lightboxClose.addEventListener('click', closeLightbox);
      }

      if (lightbox) {
        lightbox.addEventListener('click', function(event) {
          if (event.target === lightbox) closeLightbox();
        });
      }

      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
          closeLightbox();
        }
      });
    })();

    window.sbAjaxAddToCart = window.sbAjaxAddToCart || function(form) {
      const fd = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to add item');
        return response.json();
      })
      .then(function(item) {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: item
        }));

        document.dispatchEvent(new CustomEvent('cart:open', {
          bubbles: true
        }));

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: item
        }));

        const drawer = document.querySelector(
          '[data-cart-drawer], cart-drawer, .cart-drawer, #cart-drawer, .drawer--cart'
        );

        if (drawer) {
          drawer.classList.add('active', 'is-open', 'open', 'drawer--is-open');
          drawer.setAttribute('open', '');
        }
      })
      .catch(function(error) {
        console.error('add to cart failed:', error);
        form.submit();
      });

      return false;
    };
  